import movementTypes from 'modules/transactions/constants/movementTypes';
import { createMovement } from 'modules/transactions/utils/createMovement';
import { Movement, Range } from 'types';

type GetMovementsProps = {
  rangesToAdd: Range[];
  rangesToRemove: Range[];
  partnerId: string;
  holdingClassId: string;
};

export const getMovements = ({
  rangesToAdd,
  rangesToRemove,
  partnerId,
  holdingClassId,
}: GetMovementsProps): Movement[] => {
  const rangesToRemoveMovements = rangesToRemove.map(
    (range) =>
      createMovement({
        range: {
          ...range,
          partner: partnerId,
          shareClass: holdingClassId,
        },
        movementType: movementTypes.DECREMENT,
      }) as Movement
  );

  const rangesToAddMovements: Movement[] = rangesToAdd.map(
    (range) =>
      createMovement({
        range: {
          ...range,
          partner: partnerId,
          shareClass: holdingClassId,
        },
        movementType: movementTypes.INCREMENT,
      }) as Movement
  );

  const movements: Movement[] = [
    ...(rangesToRemoveMovements || []),
    ...(rangesToAddMovements || []),
  ];

  return movements;
};
